import { render, staticRenderFns } from "./PatientView.vue?vue&type=template&id=21d7c30d&scoped=true"
import script from "./PatientView.vue?vue&type=script&lang=js"
export * from "./PatientView.vue?vue&type=script&lang=js"
import style0 from "./PatientView.vue?vue&type=style&index=0&id=21d7c30d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d7c30d",
  null
  
)

export default component.exports